const state = {
  newestZhuanBao: [],
  newestTxMsg: [],
  newestUnitRisk: [],
  objsList: JSON.parse(localStorage.getItem("objsList")) || [],
  activeCountyId: JSON.parse(localStorage.getItem("activeCountyId")) || 0,
  cartData: [
    {
      name: "卡片1",
      value: true,
      types: [],
      top: 0,
      height: "23.5vh",
    },
    {
      name: "卡片2",
      value: true,
      types: [],
      top: 0,
      height: "23.5vh",
    },
    {
      name: "卡片3",
      value: true,
      types: [],
      top: 0,
      height: "23.5vh",
    },
    {
      name: "卡片4",
      value: true,
      types: [],
      top: 0,
      height: "23.5vh",
    },
    {
      name: "卡片5",
      value: true,
      types: [],
      top: 0,
      height: "23.5vh",
    },
    {
      name: "卡片6",
      value: true,
      types: [],
      top: 0,
      height: "23.5vh",
    },
  ],
  cardOptions: [],
  giftDataResult: {},
  riskForeResult: {},
  riskShortResult: {},
  tqskDateResult: {},
  slideLiveResult: {},
  rainImageResult: {},
  egObtLiveResult: [],
  indexNumberResult: {},
  suitabilityNumberResult: {},
  ultravioletRaysResult: {},
  sevenDayDataResult: {},
  unitPointDataResult: [],
  unitZjStationDataResult: [],
  riskTypeCountResult: [],
  bxIndexRecordResult: [],
  pointSlideLiveDataResult: {},
  zjzSlideLiveDataResult: {},
  stpResult: {},
  shuiWenStationSlideResult: {},
  airQualityDataResult: {},
  countyOccupantResult: {},
  refinedRainDataResult: {},
};
const mutations = {
  changeNewestZhuanBao(state, data) {
    state.newestZhuanBao = data;
  },
  changeNewestTxMsg(state, data) {
    state.newestTxMsg = data;
  },
  changeNewestUnitRisk(state, data) {
    state.newestUnitRisk = data;
  },
  changeObjsList(state, data) {
    state.objsList = data;
  },
  changeActiveCountyId(state, id) {
    state.activeCountyId = id;
  },

  // 修改卡片数据
  changeCartItem(state, option) {
    state.cartData[option.index].value = option.data.value;
    state.cartData[option.index].types = option.data.types;
  },
  changeCartHeight(state, option) {
    state.cartData[option.index].height = option.height;
  },
  // 修改卡片的显示和隐藏
  changeCartShow(state, index) {
    state.cartData[index].value = !state.cartData[index].value;
  },
  changeCartShowHidden(state, data) {
    state.cartData[data.index].value = data.show;
  },
  // 修改卡片的显示和隐藏
  changeAllCartShow(state, flag) {
    for (let index = 0; index < 6; index++) {
      state.cartData[index].value =
        state.cartData[index].types.length > 0 ? flag : false;
    }
  },
  // 直接赋值卡片数据
  changeCardOption(state, data) {
    state.cardOptions = data;
  },
  changeCardTypes(state, unit) {
    let leftHeight = 16.7;
    let rightHeight = 16.7;
    const one = [19, 9, 29, 28, 20, 36, 44, 37, 43];
    const two = [];
    const cardList = [
      "cardone",
      "cardtwo",
      "cardthree",
      "cardfour",
      "cardfive",
      "cardsix",
    ];
    cardList.forEach((name, index) => {
      state.cartData[index].types = unit[name]
        ? unit[name].split(",").map((item) => Number(item))
        : [];
      console.log("state.cartData[index].types", state.cartData[index].types);
      if (state.cartData[index].types.length < 1) {
        state.cartData[index].value = false;
      } else {
        state.cartData[index].value = true;
        if (one.includes(state.cartData[index].types[0])) {
          state.cartData[index].size = 1;
        } else if (two.includes(state.cartData[index].types[0])) {
          state.cartData[index].size = 2;
        }

        const height =
          state.cartData[index].size === 1
            ? 23.5 * state.cartData[index].size
            : 23.5 * state.cartData[index].size + 1.8;
        if (index < 3) {
          state.cartData[index].top = leftHeight + "vh";
          state.cartData[index].height = height + "vh";
          leftHeight = leftHeight + height + 1.8;
        } else {
          state.cartData[index].top = rightHeight + "vh";
          state.cartData[index].height = height + "vh";
          rightHeight = rightHeight + height + 1.8;
        }
      }
    });
  },

  // 改变六个卡片的数据
  changCardData(state, prams) {
    const filed = prams.type + "Result";
    state[filed] = prams.data;
  },
};

export default {
  state,
  mutations,
  namespaced: true,
};
